import { transformComponent } from '../../__builtins__/shared'
import { connect, mapProps, mapReadPretty } from '@formily/vue'
import RichTimePicker from './layout.vue'
import {InputPreviewText} from '../PreviewText'

const TransformRichTimePicker = transformComponent(
  RichTimePicker,
  {
    change: 'input'
  }
)

export const TimePicker = connect(
  TransformRichTimePicker,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(InputPreviewText)
)

export default TimePicker
